<template>
  <div class="guide-content">
    <div v-if="collapse" class="container-box collapse-container" @click="openContent">
      <img src="../../assets/img/icon_deng_pao.svg" width="32" alt="" />
    </div>
    <div v-else class="container-box fold-container">
      <div class="guide-header">
        <div class="guide-header-left">
          <img src="../../assets/img/icon_deng_pao.svg" width="24" alt="" />
          <span>快捷帮助</span>
        </div>
        <i class="iconfont icon-zuixiaohua icon-close" @click="closeContent" />
      </div>
      <ul class="guide-ul">
        <li class="guide-li" @click="openGuide">
          <div class="main-text">新手指引</div>
          <div class="sub-text">如何快速上手共享云盘？点我了解详情</div>
        </li>
        <li class="guide-li" @click="openFunction">
          <div class="main-text">功能说明</div>
          <div class="sub-text">共享云盘有哪些功能？点我了解详情</div>
        </li>
        <li class="guide-li" @click="openQuestion">
          <div class="main-text">常见问题</div>
          <div class="sub-text">使用遇到问题？查看常见问题解决办法</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import openUrlMixin from '@/mixins/openUrlMixin'
import StorageUtils from '@/core/storageUtils'
import { hasLoginCachePath, writeFile, checkExistFile } from '@/core/desktopCache'
export default {
  name: 'GuideForNew',
  mixins: [openUrlMixin],
  data() {
    return {
      collapse: true,
      isFirstLogin: undefined,
    }
  },
  computed: {
    ...mapGetters({
      getConfig: 'staticConfig/getConfig'
    }),
    // 文档的链接地址
    urls() {
      const linkUrls = this.getConfig('linkUrls') || {}
      return linkUrls.guideForNew || {}
    }
  },
  watch: {
    isFirstLogin: {
      handler(val) {
        this.collapse = this.$route.name !== 'Index' || !val
      },
    },
    '$route.name': {
      async handler(val) {
        if (val === 'Index') {
          await this.checkIsFirstLogin()
          this.collapse = !this.isFirstLogin
        } else {
          this.collapse = true
        }
      },
      immediate: true
    }
  },
  methods: {
    async checkIsFirstLogin() {
      if (this.platform === 'web') {
        const hasLogin = StorageUtils.localStorage.get('hasLogin')
        this.isFirstLogin = !hasLogin
        if (!hasLogin) {
          StorageUtils.localStorage.set('hasLogin', true)
        }
      } else {
        const flag = await checkExistFile(hasLoginCachePath())
        this.isFirstLogin = !flag
        if (flag === false) {
          await writeFile(hasLoginCachePath(), JSON.stringify({ hasLogin: true }))
        }
      }
    },
    openContent() {
      this.collapse = false
    },
    closeContent() {
      this.collapse = true
    },
    openGuide() {
      const url = this.urls.guideUrl || 'https://kdocs.cn/l/ccU86e3QIYle'
      this.openUrl(url)
    },
    openFunction() {
      const url = this.urls.functionUrl || 'https://kdocs.cn/l/cnAh6xY3sbHR?linkname=Pfv0m1zQUa'
      this.openUrl(url)
    },
    openQuestion() {
      const url = this.urls.questionUrl || 'https://kdocs.cn/l/cnAh6xY3sbHR?linkname=RNnVPFYIU9'
      this.openUrl(url)
    },
  }
}
</script>

<style lang="less" scoped>
.guide-content{
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 100;
.container-box{
  border-radius: 12px;
  background: #FFFFFF;
  box-shadow: 0 2px 0 0 rgba(131, 176, 255, 0.3),0 4px 8px 0 rgba(29, 57, 111, 0.3);
}
}
.collapse-container{
  padding: 6px;
  cursor: pointer;
}
.fold-container{
  padding: 20px;
  .guide-header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #495F70;
    margin-bottom: 16px;
    .guide-header-left{
      display: flex;
      align-items: center;
    }
    i{
      font-size: 20px;
    }
    .icon-close{
      cursor: pointer;
    }
  }
}

.guide-li{
  border-radius: 8px;
  background: #EDF0FF;
  color: #1F33A8;
  padding: 14px 16px;
  margin-bottom: 10px;
  cursor: pointer;
  .main-text{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .sub-text{
    font-size: 12px;
  }
}
</style>
